import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useImperativeHandle, useContext } from "react";
import Input from "./FormControl";
import Group from "../../wui-input-group/src/index";
import Button from "./InputGroupButton";
import { ConfigContext } from "../../wui-provider/src/context";

var InputWithProvider = function InputWithProvider(props, ref) {
  var inputRef = useRef();
  var context = useContext(ConfigContext); // TODO: 将来统一config之后，注入到props里面

  useImperativeHandle(ref, function () {
    return _objectSpread({
      input: inputRef.current.input,
      focus: function focus() {
        return inputRef.current.input.focus();
      }
    }, inputRef.current);
  });
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    ref: inputRef
  }));
};

var InputWrapper = /*#__PURE__*/React.forwardRef(InputWithProvider);
["TextArea", "Search", "Password"].forEach(function (item) {
  var typeName = item.toLowerCase();

  var Comp = function Comp(_ref, ref) {
    var type = _ref.type,
        others = _objectWithoutProperties(_ref, _excluded);

    return InputWithProvider(_objectSpread(_objectSpread({}, others), {}, {
      type: typeName
    }), ref);
  };

  InputWrapper[item] = /*#__PURE__*/React.forwardRef(Comp);
});
InputWrapper.Group = Group;
InputWrapper.Button = Button;
InputWrapper.propTypes = Input.propTypes;
export default InputWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-input/src/index.js